<div
  class="tw-h-19 tw-border-b tw-border-[#f0f0f0] tw-bg-white hb-group:tw-border-none hb-group:tw-p-4 md:tw-px-8 hb-group:md:tw-py-4 hb-group:md:tw-pl-8"
>
  <a [href]="homePageUrl() || null">
    <img
      [ngSrc]="'/apps/ia-parrainage-filleul/images/' + logo.file + '.webp'"
      [width]="logo.width"
      [height]="logo.height"
      alt="logo"
      priority
    />
  </a>
</div>
